import React, { Component } from 'react';
import { Button, Modal } from 'reactstrap';
//config
import { REST_KEY } from '../../config/config';
import Api from '../../config/Api';

//component
import Notif from '../Notification/Notif';

export default class ModalHapus extends Component {
	state = {
		hapusModal: false,
		tombol: this.props.tombol,
	};

	toggleModal = (state) => {
		this.setState({
			[state]: !this.state[state],
			loading: true,
			token_api: REST_KEY,
			url_wb: this.props.url_wb,
			id: this.props.id,
			judul: this.props.judul,
			isi: this.props.isi,
		});
	};
	hapus = async (e) => {
		this.setState({
			loading: true,
		});
		await Api.post(this.state.url_wb, this.state).then((b) => {
			this.setState({
				message: b.data.message,
				indicator: b.data.indicator,
				icon: b.data.icon,
				loading: false,
			});
		});
		this.props.refresh();
		this.toggleModal('hapusModal');
		if (this.state.indicator) {
			Notif(this.state.indicator, this.state.icon, sessionStorage.getItem('namaAdmin'), this.state.message);
		}
	};
	render() {
		let Tombol = '';
		if (this.state.tombol === 'TableList') {
			Tombol = (
				<Button
					className="btn-icon btn-2"
					color="danger"
					type="button"
					onClick={() => this.toggleModal('hapusModal')}
				>
					<span className="btn-inner--icon">
						<i className="fa fa-trash" />
					</span>
				</Button>
			);
		}
		if (this.state.tombol === 'sm-icon') {
			Tombol = (
				<Button color="danger" size="sm" onClick={() => this.toggleModal('hapusModal')}>
					<i className="fa fa-trash fa-2x"></i>
				</Button>
			);
		}
		if (this.state.tombol === 'sm-icon-absolute') {
			Tombol = (
				<Button
					color="danger"
					size="sm"
					onClick={() => this.toggleModal('hapusModal')}
					style={{
						position: 'absolute',
						right: '9px',
					}}
				>
					<i className="fa fa-trash"></i>
				</Button>
			);
		}

		return (
			<>
				{Tombol}

				<Modal
					className="modal-dialog-centered modal-danger"
					contentClassName="bg-gradient-danger"
					isOpen={this.state.hapusModal}
					toggle={() => this.toggleModal('hapusModal')}
				>
					<div className="modal-header">
						<h6 className="modal-title" id="modal-title-notification">
							HAPUS
						</h6>
						<button
							aria-label="Close"
							className="close"
							data-dismiss="modal"
							type="button"
							onClick={() => this.toggleModal('hapusModal')}
						>
							<span aria-hidden={true}>×</span>
						</button>
					</div>
					<div className="modal-body">
						<div className="py-3 text-center">
							<i className="ni ni-bell-55 ni-3x" />
							<h4 className="heading mt-4">{this.state.judul}!</h4>
							<p>
								Apakah Anda Akan Menghapus
								<strong className="text-success"> {this.state.isi}</strong>?
							</p>
						</div>
					</div>
					<div className="modal-footer">
						<Button className="btn-white" color="default" type="button" onClick={this.hapus}>
							Ya
						</Button>
						<Button
							className="text-white ml-auto"
							color="link"
							data-dismiss="modal"
							type="button"
							onClick={() => this.toggleModal('hapusModal')}
						>
							Tidak
						</Button>
					</div>
				</Modal>
			</>
		);
	}
}
